import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import CommunityResilienceRecoveryDetails from '../../subdepartmentdetails/CommunityResilienceRecovery'


function CommunityResilienceRecovery() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Community Resilience and Recovery Programs || Emergency Management";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Emergency Management"
            title="Community Resilience Recovery"
            subtitledown="Department of Emergency Management"
           />
            <CommunityResilienceRecoveryDetails/>
        </div>
    </>
  )
}

export default CommunityResilienceRecovery